var map = {
	"./Amount.png": "./src/assets/images/Amount.png",
	"./EyeInvisibleOutlined.png": "./src/assets/images/EyeInvisibleOutlined.png",
	"./EyeTwoTone.png": "./src/assets/images/EyeTwoTone.png",
	"./Group.png": "./src/assets/images/Group.png",
	"./Huge-icon.png": "./src/assets/images/Huge-icon.png",
	"./Icons_Cross.png": "./src/assets/images/Icons_Cross.png",
	"./add-icon.png": "./src/assets/images/add-icon.png",
	"./address-marker.png": "./src/assets/images/address-marker.png",
	"./address.png": "./src/assets/images/address.png",
	"./assign-delay-time.png": "./src/assets/images/assign-delay-time.png",
	"./back-icon.png": "./src/assets/images/back-icon.png",
	"./calendar-t.png": "./src/assets/images/calendar-t.png",
	"./calendar.png": "./src/assets/images/calendar.png",
	"./check-ed.png": "./src/assets/images/check-ed.png",
	"./check.png": "./src/assets/images/check.png",
	"./clock-icon.png": "./src/assets/images/clock-icon.png",
	"./completed-task.png": "./src/assets/images/completed-task.png",
	"./coupon-customer.png": "./src/assets/images/coupon-customer.png",
	"./default-avatar.png": "./src/assets/images/default-avatar.png",
	"./delete-icon.png": "./src/assets/images/delete-icon.png",
	"./download.png": "./src/assets/images/download.png",
	"./edit-icon.png": "./src/assets/images/edit-icon.png",
	"./faastaa_logo.png": "./src/assets/images/faastaa_logo.png",
	"./feedback.png": "./src/assets/images/feedback.png",
	"./female@2x.png": "./src/assets/images/female@2x.png",
	"./in-progress.png": "./src/assets/images/in-progress.png",
	"./left-icon.png": "./src/assets/images/left-icon.png",
	"./left.png": "./src/assets/images/left.png",
	"./llama/llama-1-bad.png": "./src/assets/images/llama/llama-1-bad.png",
	"./llama/llama-2-poor.png": "./src/assets/images/llama/llama-2-poor.png",
	"./llama/llama-3-okay.png": "./src/assets/images/llama/llama-3-okay.png",
	"./llama/llama-4-good.png": "./src/assets/images/llama/llama-4-good.png",
	"./llama/llama-5-excellent.png": "./src/assets/images/llama/llama-5-excellent.png",
	"./loading-icon3.png": "./src/assets/images/loading-icon3.png",
	"./loading.png": "./src/assets/images/loading.png",
	"./logo.png": "./src/assets/images/logo.png",
	"./logout-icon.png": "./src/assets/images/logout-icon.png",
	"./male@2x.png": "./src/assets/images/male@2x.png",
	"./no-star.png": "./src/assets/images/no-star.png",
	"./open-menu.png": "./src/assets/images/open-menu.png",
	"./other@2x.png": "./src/assets/images/other@2x.png",
	"./pay-icon.png": "./src/assets/images/pay-icon.png",
	"./play.png": "./src/assets/images/play.png",
	"./radio-ed.png": "./src/assets/images/radio-ed.png",
	"./radio.png": "./src/assets/images/radio.png",
	"./re-upload.png": "./src/assets/images/re-upload.png",
	"./report.png": "./src/assets/images/report.png",
	"./reviews.png": "./src/assets/images/reviews.png",
	"./right-icon.png": "./src/assets/images/right-icon.png",
	"./right.png": "./src/assets/images/right.png",
	"./search-icon.png": "./src/assets/images/search-icon.png",
	"./select-icon.png": "./src/assets/images/select-icon.png",
	"./select_icon.png": "./src/assets/images/select_icon.png",
	"./selected.png": "./src/assets/images/selected.png",
	"./send-msg-c.png": "./src/assets/images/send-msg-c.png",
	"./send-msg.png": "./src/assets/images/send-msg.png",
	"./star.png": "./src/assets/images/star.png",
	"./task-active.png": "./src/assets/images/task-active.png",
	"./task-c.png": "./src/assets/images/task-c.png",
	"./tasker-approval-approved.png": "./src/assets/images/tasker-approval-approved.png",
	"./tasker-approval-reject.png": "./src/assets/images/tasker-approval-reject.png",
	"./tasker-approval-view.png": "./src/assets/images/tasker-approval-view.png",
	"./tip-trigger.png": "./src/assets/images/tip-trigger.png",
	"./upload-img.png": "./src/assets/images/upload-img.png",
	"./view-more.png": "./src/assets/images/view-more.png",
	"./work-address-icon.png": "./src/assets/images/work-address-icon.png",
	"./work-pay-icon.png": "./src/assets/images/work-pay-icon.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.png$";